import * as React from 'react';
import { Segment, Container, Grid, Header } from 'semantic-ui-react';

const IntroSegment = () =>
  <Segment vertical style={{ padding: '4em 0em 4em 0em', backgroundColor: "#F2F3F5", fontSize: '1.33em' }}>
    <Container>
      <Grid container stackable>
        <Grid.Row centered>
          <Header style={{ fontSize: "2em" }}>Whoops! Page Not Found :(</Header>
        </Grid.Row>        
      </Grid>

    </Container>
  </Segment>

export default IntroSegment



// WEBPACK FOOTER //
// ./src/page-not-found/IntroSegment.tsx